import React, {Component, PropTypes} from 'react';
import {
  Button,
  Modal,
  FormGroup,
  Form,
  Col,
  FormControl,
  ControlLabel,
} from '@sketchpixy/rubix';
import styled from 'styled-components';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

import ServiceType from '../../../constants/ServiceType';

import {
   getContentClient,
   updateContentClient
} from '../../../api/api';

const override = css`
margin-top: -550px;
`;

class ContentClientEditModal extends Component {
  constructor(props) {
    super(props);

    this.onFileChange = this.onFileChange.bind(this);

    this.state = {
      contentClient : {
         contentClientId: null,
         downloadUrl: '',
         file:null,
         packageName: '',
         versionName: '',
         versionCode: '',
         rapaelClientId: ''
      },
      file:'',
      loading: false
    };
  }

  onPackageNameChange = (event) => {
    var contentClient= {...this.state.contentClient}
    contentClient.packageName = event.target.value;
    this.setState({
      contentClient: contentClient,
    });
  }

  onVersionNameChange = (event) => {
    var contentClient= {...this.state.contentClient}
    contentClient.versionName = event.target.value;
    this.setState({
      contentClient: contentClient,
    });
  }

  onVersionCodeChange = (event) => {
    var contentClient= {...this.state.contentClient}
    contentClient.versionCode = event.target.value;
    this.setState({
      contentClient: contentClient,
    });
  }

  onFileChange(e) {
    this.setState({
      file: e.target.files[0],
    });
  }


  saveContentClient = (event) => {
     let self = this;
     const formData = new FormData();
     if(self.state.file !== '')
     {
         formData.append('file',self.state.file);
     }

     _.forOwn(self.state.contentClient, function(value, key) {
       if(value)
       {
           formData.append(key, value);
       }
     });

     self.setState({
         loading: true,
     });
     updateContentClient(formData, (err, res) => {
         self.setState({
             loading: false,
         });
         if (err) {
            vex.dialog.alert('Failed to update Content!');
          } else {
            vex.dialog.alert('Content Updated!');
            self.setState({
                contentClient: res.client,
                file: null
              }, () => {
              });
          }
     });
  }

  onShowModal = (evt) => {
    if(this.props.contentClientId)
    {
        getContentClient(this.props.contentClientId, (err, res) => {
          this.setState({
              contentClient: res.client,
          });
        });
    }else{
        let contentClient = {
            contentClientId: null,
            downloadUrl: '',
            file:null,
            packageName: '',
            versionName: '',
            versionCode: '',
            rapaelClientId: ''
        };

        if(this.props.rapaelClientId)
        {
            contentClient.rapaelClientId =  this.props.rapaelClientId;
        }

        this.setState({
            contentClient: contentClient,
        });
    }
  }

  render() {
    return (
        <Modal
            show={this.props.showModal}
            onHide={this.props.closeModal}
            onEntered = {this.onShowModal}
            backdrop="static"
            style={{width:'100%'}}
        >
          <Modal.Header closeButton>
            <Modal.Title>Edit Content Client</Modal.Title>
          </Modal.Header>
          <Modal.Body>
             <Form>
                 <FormGroup controlId="formControlsFile">
                      <ControlLabel>Attach APK</ControlLabel>
                      <FormControl type="file" name="file" onChange={this.onFileChange}/>
                 </FormGroup>
                 {this.props.contentClientId && (
                    <FormGroup controlId='readOnly'>
                         <ControlLabel>Attached APK</ControlLabel>
                         <FormControl readOnly type='text' placeholder='Attached File' value={this.state.contentClient.downloadUrl.split('/').pop()}/>
                    </FormGroup>
                 )}
                 <FormGroup>
                      <ControlLabel>Package Name</ControlLabel>
                      <FormControl type='text' placeholder='Package Name'  value={this.state.contentClient.packageName} onChange={this.onPackageNameChange}/>
                 </FormGroup>
                 <FormGroup>
                      <ControlLabel>Version Name</ControlLabel>
                      <FormControl type='text' placeholder='Version Name'  value={this.state.contentClient.versionName} onChange={this.onVersionNameChange}/>
                 </FormGroup>
                 <FormGroup>
                      <ControlLabel>Version Code</ControlLabel>
                      <FormControl type='text' placeholder='Version Code'  value={this.state.contentClient.versionCode} onChange={this.onVersionCodeChange}/>
                 </FormGroup>
             </Form>
             <ClipLoader
             className={override}
             sizeUnit={'px'}
             size={500}
             color={'#123abc'}
             loading={this.state.loading}>
             </ClipLoader>
          </Modal.Body>
          <Modal.Footer>
            <Button bsStyle='primary' onClick={this.saveContentClient}>Save</Button>
            <Button onClick={this.props.closeModal}>Cancel</Button>
          </Modal.Footer>
        </Modal>
    );
  }
}

ContentClientEditModal.propTypes = {
  contentClientId: PropTypes.number,
  rapaelClientId: PropTypes.number,
  showModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};

export default ContentClientEditModal;



// WEBPACK FOOTER //
// ./src/routes/ReleaseMgnt/components/ContentClientEditModal.js